var __jsx = React.createElement;
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import { useStore } from "@dp/state";
import { useRouter } from "next/router";
import i18next from "i18next";
var MyAccount = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MyAccount;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var OrderHistory = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.OrderHistory;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var PageWrapper = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.PageWrapper;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var OrderHistoryPage = function OrderHistoryPage() {
  var _router$asPath$split;
  var store = useStore();
  var router = useRouter();
  var isMobile = store === null || store === void 0 ? void 0 : store.isMobile;
  var activeTab = router === null || router === void 0 || (_router$asPath$split = router.asPath.split("/")) === null || _router$asPath$split === void 0 || (_router$asPath$split = _router$asPath$split.pop()) === null || _router$asPath$split === void 0 || (_router$asPath$split = _router$asPath$split.split("#")) === null || _router$asPath$split === void 0 ? void 0 : _router$asPath$split[0];
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("MyAccount")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      var _store$user, _store$user2, _store$user3;
      if (!(store !== null && store !== void 0 && (_store$user = store.user) !== null && _store$user !== void 0 && _store$user.isLoggedIn)) {
        // redirect to handle auth
        store === null || store === void 0 || store.platformUtil.navigateToRoute("/customer-service/handle-auth-urls");
      }
      store === null || store === void 0 || (_store$user2 = store.user) === null || _store$user2 === void 0 || (_store$user2 = _store$user2.userProfileModel) === null || _store$user2 === void 0 || _store$user2.setActiveTab(activeTab);
      store === null || store === void 0 || (_store$user3 = store.user) === null || _store$user3 === void 0 || (_store$user3 = _store$user3.analyticsModel) === null || _store$user3 === void 0 || _store$user3.dispatchPageViewEvent();
    });
  }, []);
  if (isMobile) {
    return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.orderhistory.pagetitle", {
      defaultValue: "Order History"
    }))), __jsx(PageWrapper, null, __jsx(OrderHistory, null)));
  }
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.orderhistory.pagetitle", {
    defaultValue: "Order History"
  }))), __jsx(MyAccount, {
    isEditing: false
  }));
};
OrderHistoryPage.layout = PageLayout.NB_LAYOUT;
OrderHistoryPage.layoutProps = {
  analyticsData: {
    pageName: "customer-service|order-history",
    pageType: "customer-service",
    primaryCategory: "Account flow"
  }
};
export default observer(OrderHistoryPage);